import { createContext, useContext, useEffect, useState } from "react";
import api, { clearTokens } from "@/lib/api";
import { canAccess } from "@/lib/perms";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const boot = async () => {
      if (!localStorage.getItem("access_token") && localStorage.getItem("refresh_token")) {
        try {
          const { data } = await api.post("/auth/refresh", { refresh_token: localStorage.getItem("refresh_token") });
          localStorage.setItem("access_token", data.access_token);
        } catch (e) { /* fall through to /me */ }
      }
      api.get("/auth/me")
        .then(({ data }) => setUser(data))
        .catch(() => setUser(false));
    };
    boot();
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    clearTokens();
    setUser(false);
  };

  const can = (perm) => canAccess(user, perm);

  return (
    <AuthContext.Provider value={{ user, setUser, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
